import script from "./MeasureGridMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MeasureGridMenu.vue?vue&type=script&setup=true&lang=js"

import "./MeasureGridMenu.vue?vue&type=style&index=0&id=08879d7d&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08879d7d"]])

export default __exports__